import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyRateModalService {

  private selectedCurrencyRateSubject = new BehaviorSubject<any>(null);
  public selectedCurrencyRate$ = this.selectedCurrencyRateSubject.asObservable();

  constructor() { }

  setSelectedCurrencyRate(currencyRate: any): void {
    this.selectedCurrencyRateSubject.next(currencyRate);
  }

  getSelectedCurrencyRate(): any | null {
    return this.selectedCurrencyRateSubject.value;
  }

  clearSelectedCurrencyRate(): void {
    this.selectedCurrencyRateSubject.next(null);
  }
}

